var React = require('react');

function MinusSmall (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8 11h8c.6 0 1 .4 1 1s-.4 1-1 1H8c-.6 0-1-.4-1-1s.4-1 1-1z"}));
}

MinusSmall.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = MinusSmall;

MinusSmall.default = MinusSmall;
